import { css } from "@emotion/css";
import { CodeBranchIcon } from "@octopusdeploy/design-system-icons";
import { space } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { withTheme } from "~/components/Theme";
import WarningIcon from "~/components/WarningIcon/index";
export function GitProjectLinkWithErrorStatus(props: {
    label: string | JSX.Element;
    hasError: boolean;
}) {
    return withTheme((theme) => {
        const icon = props.hasError ? <WarningIcon color={theme.errorText}/> : undefined;
        return <IconProjectLink {...props} icon={icon}></IconProjectLink>;
    });
}
export function GitProjectLink(props: {
    label: string | JSX.Element;
}) {
    const icon = <CodeBranchIcon size={16} ariaLabel="Git icon"/>;
    return <IconProjectLink {...props} icon={icon}></IconProjectLink>;
}
export function IconProjectLink(props: {
    label: string | JSX.Element;
    icon: JSX.Element | undefined;
}) {
    return (<div className={linkContainerStyles}>
            <span>{props.label}</span>
            {props.icon && <span className={iconStyles}>{props.icon}</span>}
        </div>);
}
const linkContainerStyles = css({
    display: "flex",
    alignItems: "center",
    gap: space[8],
});
// Adjusts the optical alignment of the icon next to the text
const iconStyles = css({
    top: "1px",
    position: "relative",
});
